import { useState } from "react";
import GraphViewSelector from "./graph/GraphViewSelector";
import MetricChart from "./graph/MetricChart";
import { ProfitAndLossMonthlyGraphData } from "@/types/profit-and-loss-monthly-graph-api";
import LoadingPage from "../LoadingPage";
import { useTranslation } from "react-i18next";
import { formatMonthRange } from "@/lib/time_utils";
import { H4, Meta1 } from "../ui/Typography";

interface ProfitAndLossGraphProps {
  data: ProfitAndLossMonthlyGraphData | null | undefined;
}

const getYearsFromData = (months: string[]) => {
  const endYear = new Date(months[0]).getFullYear();
  const startYear = endYear - 1;
  return { startYear, endYear };
};

const ProfitAndLossGraph = (props: ProfitAndLossGraphProps) => {
  const { t } = useTranslation("common");
  const [metricType, setMetricType] = useState("income");

  if (!props.data) return <LoadingPage />;

  const graphData = props.data;
  const { startYear, endYear } = getYearsFromData(graphData.months);

  return (
    <div className="bg-white rounded-2xl w-full p-8 shadow-sm">
      <div className="text-center mb-4">
        <Meta1 className="text-center">{t("profit_and_loss:title")} </Meta1>
        <H4 className="text-center">{formatMonthRange(graphData.months)}</H4>
        <Meta1 className="text-center">
          {t("comparison_against")} {startYear}
        </Meta1>
      </div>

      <div className="mb-[5px] flex justify-end">
        <GraphViewSelector onChange={setMetricType} />
      </div>

      <MetricChart
        data={graphData}
        metricType={metricType}
        startYear={startYear}
        endYear={endYear}
      />
    </div>
  );
};

export default ProfitAndLossGraph;
